/**
 * The shop's money format string (e.g. "£{{amount}}") is set as window.moneyFormat
 * via an inline <script> in layout/theme.liquid before this file loads.
 * Pass window.moneyFormat as the second argument to formatMoney() calls.
 */

/**
 * Formats a monetary value in cents to a formatted string
 * @param {number|string} cents - The amount in cents to format
 * @param {string} [format="${{amount}}"] - The format string (e.g., "${{amount}}", "€{{amount_with_comma_separator}}")
 * @returns {string} The formatted money string
 * @example
 * formatMoney(1999, "${{amount}}") // Returns "$19.99"
 * formatMoney(1999, "€{{amount_with_comma_separator}}") // Returns "€19,99"
 */
function formatMoney(cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || "${{amount}}";

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

if (!customElements.get("m-cart-upsell")) {
  class CartUpsell extends HTMLElement {
    connectedCallback() {
      this.onDrawerOpen = () => {
        window.requestAnimationFrame(() => this.mountSlider());
      };

      const boot = () => {
        if (this.offsetWidth > 0) this.mountSlider();
        if (window.MinimogEvents) {
          this.unsubscribeOpen = window.MinimogEvents.subscribe("ON_OPEN_DRAWER_CART", this.onDrawerOpen);
        }
      };

      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", boot, { once: true });
      } else {
        boot();
      }
    }

    disconnectedCallback() {
      if (this.unsubscribeOpen) this.unsubscribeOpen();
      if (this.slider) {
        this.slider.destroy();
        this.slider = null;
      }
    }

    mountSlider() {
      if (!window.MinimogLibs || !window.MinimogLibs.Swiper) return;
      if (this.slider) {
        this.slider.update();
        return;
      }

      const container = this.querySelector(".swiper-container");
      const wrapper = container && container.querySelector(".swiper-wrapper");
      if (!container || !wrapper) return;

      const slideCount = wrapper.children.length;
      if (!slideCount) return;

      const showNavigation = this.dataset.showNavigation === "true";
      const items = parseInt(this.dataset.items, 10) || 3;
      const perView = Math.min(items, slideCount);
      const controls = this.querySelector(".sf-slider__controls");
      const prevButton = controls && controls.querySelector(".sf-slider__controls-prev");
      const nextButton = controls && controls.querySelector(".sf-slider__controls-next");

      const syncControls = (swiper, slidesPerView) => {
        if (!controls) return;
        const visible = parseInt(slidesPerView, 10) || 1;
        if (slideCount > visible) {
          controls.classList.remove("hidden");
          swiper.allowTouchMove = true;
        } else {
          controls.classList.add("hidden");
          swiper.allowTouchMove = false;
        }
      };

      const options = {
        slidesPerView: perView,
        slidesPerGroup: perView,
        watchOverflow: true,
        threshold: 2,
        loop: false,
        pagination: false,
        on: {
          init: (swiper) => {
            syncControls(swiper, swiper.params.slidesPerView);
          },
        },
      };

      this.slider = new window.MinimogLibs.Swiper(container, options);

      if (this.slider && showNavigation) {
        if (prevButton) prevButton.addEventListener("click", () => this.slider.slidePrev());
        if (nextButton) nextButton.addEventListener("click", () => this.slider.slideNext());
      }
    }
  }

  customElements.define("m-cart-upsell", CartUpsell);
}
document.addEventListener("click", function (event) {
  var button = event.target.closest("[data-recommendations-add-all]");
  if (!button || button.classList.contains("sf-spinner-loading")) return;

  var header = button.closest(".product-recommendations__header");
  var errorNode = header ? header.querySelector("[data-add-all-error]") : null;
  var variantIds = (button.getAttribute("data-variant-ids") || "")
    .split(",")
    .map(function (id) {
      return parseInt(id, 10);
    })
    .filter(function (id, index, ids) {
      return id && ids.indexOf(id) === index;
    });

  if (!variantIds.length) return;

  if (errorNode) {
    errorNode.hidden = true;
    errorNode.textContent = "";
  }

  button.classList.add("sf-spinner-loading");
  button.disabled = true;
  button.setAttribute("aria-busy", "true");

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
    body: JSON.stringify({
      items: variantIds.map(function (id) {
        return { id: id, quantity: 1 };
      }),
    }),
  })
    .then(function (response) {
      return response.json().then(function (data) {
        return { ok: response.ok, data: data };
      });
    })
    .then(function (result) {
      if (!result.ok) {
        var message =
          (result.data && (result.data.description || result.data.message)) ||
          button.getAttribute("data-error-message") ||
          "Could not add these products to the cart.";
        if (errorNode) {
          errorNode.textContent = message;
          errorNode.hidden = false;
        }
        return;
      }

      var items = (result.data && result.data.items) || [];
      if (items.length && window.Shopify && typeof window.Shopify.onItemAdded === "function") {
        window.Shopify.onItemAdded(items[0]);
      }
    })
    .catch(function () {
      if (errorNode) {
        errorNode.textContent =
          button.getAttribute("data-error-message") ||
          "Could not add these products to the cart.";
        errorNode.hidden = false;
      }
    })
    .finally(function () {
      button.classList.remove("sf-spinner-loading");
      button.disabled = false;
      button.removeAttribute("aria-busy");
    });
});
/**
 * The product page variant picker rewrites the selling price in the browser.
 * Keep the including-VAT and excluding-VAT amounts on the main price in step.
 */
(function () {
  var VAT_MULTIPLIER = 1.2;

  function moneyFormat() {
    if (window.MinimogSettings && window.MinimogSettings.money_format) {
      return window.MinimogSettings.money_format;
    }
    return window.moneyFormat;
  }

  function setMoney(node, cents) {
    if (!node) return;
    node.textContent = formatMoney(Math.round(cents), moneyFormat());
  }

  function updateMainPrice(variant) {
    var root = document.querySelector("[data-main-price]");
    if (!root || !variant) return;

    setMoney(root.querySelector("[data-price-inc]"), variant.price * VAT_MULTIPLIER);
    setMoney(root.querySelector("[data-price-ex]"), variant.price);

    var compare = root.querySelector("[data-compare-price]");
    var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    if (compare) compare.hidden = !onSale;
    if (!onSale) return;

    setMoney(root.querySelector("[data-compare-inc]"), variant.compare_at_price * VAT_MULTIPLIER);
  }

  function bindMainPrice() {
    var productId = document.body.dataset.productId;
    if (!productId || !window.MinimogEvents || typeof window.MinimogEvents.subscribe !== "function") return;
    window.MinimogEvents.subscribe(productId + "__VARIANT_CHANGE", updateMainPrice);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bindMainPrice);
  } else {
    bindMainPrice();
  }
})();
